import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useMutation } from "@apollo/client";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
//import { useParams } from "react-router-dom";
// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";

// Images
import bgImage from "assets/images/admin.png";
import {
  //ALL_VOTES,
  ALL_SECTIONS,
  //CREATE_VOTING,
  DELETE_COMMENT,
  ALL_COMMENTS,
  LOCK_COMMENT,
} from "../queries";
/* eslint-disable react/prop-types */
const Commentsadmin = ({ setError }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  const [sections, setSections] = useState([]);
  const [comments, setComments] = useState([]);
  const [t] = useTranslation("common");
  const sectionss = useQuery(ALL_SECTIONS, {
    pollInterval: 1000000,
  });
  useEffect(() => {
    let sectionsss = [];
    //let municipalitiess = [];
    if (sectionss.data) {
      sectionsss = sectionss.data.allSections;
      //setOrgans(organss);
      //console.log(sectionsss);
      setSections(sectionsss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [sectionss]);
  //sectionss = useParams().id;
  let valittu = [];
  if (sections) {
    valittu = sections.filter(function (el) {
      return el.id === sectionss;
    });
  }
  const commentss = useQuery(ALL_COMMENTS, {
    pollInterval: 1000000,
  });
  useEffect(() => {
    let commentsss = [];
    //let municipalitiess = [];
    if (commentss.data) {
      commentsss = commentss.data.allComments;
      //setOrgans(organss);
      //console.log(commentsss);
      setComments(commentsss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [commentss]);
  //sectionss = useParams().id;
  if (comments) {
    // eslint-disable-next-line
    valittu = comments.filter(function (el) {
      return el.id === commentss;
    });
  }
  const [deleteComment] = useMutation(DELETE_COMMENT, {
    refetchQueries: [{ query: ALL_COMMENTS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  //console.log(valittu);
  ////console.log(comment.data)
  /*const [createVoting] = useMutation(CREATE_VOTING, {
    refetchQueries: [{ query: ALL_VOTES }],
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },*/
  /*
    update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  //});
  /*const uusi = async (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    createVoting({
      variables: { commentid:event, userid: userid.length > 0 ? userid : "tyhjä", votedatetime:pvm.toString(), sectionid:sectionss }
      });
  };*/
  /*for(let i=0;i<valitut.length;i++){
    valitut[i].maara=0
    Object.preventExtensions(valitut)
  }*/
  //const maarat = aanetasiat => aanetasiat.reduce((prev, curr) => (prev[curr] = ++prev[curr] || 1, prev), {})s
  const [lockComment] = useMutation(LOCK_COMMENT, {
    refetchQueries: [{ query: ALL_COMMENTS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  const setDelete = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    deleteComment({
      variables: { id: event },
    });
    //muutetaan activated !actived edituser
  };
  const setLocked = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    lockComment({
      variables: { id: event, active: false },
    });
    //muutetaan activated !actived edituser
  };
  const setUnlocked = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    lockComment({
      variables: { id: event, active: true },
    });
    //muutetaan activated !actived edituser
  };
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 250px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="black"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Kommentit Admin{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="black"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              {comments.map((p) => (
                <>
                  <Button
                    key={p.meetingtext}
                    variant="contained"
                    size="normal"
                    color="inherit"
                    component={Link}
                    to={`/agendas/${p.id}`}
                  >
                    {p.commentid}: {p.commenttext}
                  </Button>
                  <br />
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    onClick={() => {
                      if (window.confirm("Haluatko varmasti poistaa kommentin?")) {
                        setDelete(p.id);
                      }
                    }}
                  >
                    {t("common.delete")}
                  </Button>
                  <br />
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    onClick={() => {
                      if (window.confirm("Haluatko varmasti lukita kommentin?")) {
                        setLocked(p.id);
                      }
                    }}
                  >
                    {t("common.lock")}
                  </Button>
                  <br />
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    onClick={() => {
                      if (window.confirm("Haluatko varmasti poistaa lukituksen kommentista?")) {
                        setUnlocked(p.id);
                      }
                    }}
                  >
                    {t("common.unlock")}
                  </Button>
                  <br />
                  <br />
                </>
              ))}
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default Commentsadmin;
